import React from 'react';

export default function PageHeading({ eyebrow, title, children }) {
  return <header className="page-heading">
    <span className="page-eyebrow">{eyebrow}</span>
    <h1>{title}</h1>
    {children && <p>{children}</p>}
  </header>;
}

export function AccountAvatar({ username }) {
  return <span className="account-avatar" aria-hidden="true">{(username || 'K').slice(0, 1).toUpperCase()}</span>;
}
